<!-- A button that opens an Info Modal -->
<script setup lang="ts">
import { useStore } from 'vuex';
import RulerIcon from "../../icons/RulerIcon.vue";

interface Props {
	modalName: string;
	label: string;
}
const props = defineProps<Props>();

const store = useStore();

function showInfoModal() {
	store.commit('updateCurrentModalName', props.modalName);
}
</script>

<template>
	<button class="instructions-button" type="button" v-on:click="showInfoModal">
		<ruler-icon />
		<span class="instructions-button__text">{{label}}</span>
	</button>
</template>

<style scoped lang="scss">
.instructions-button {
	margin: 0;
	padding: 0;
	font-weight: 700;
	display: flex;
	gap:5px;
	align-items: center;
	white-space: normal;
	text-align: left;
}
.instructions-button > svg {
	flex-shrink: 0;
	width: 100%;
	height: 100%;
	max-width: 16px;
	max-height: 16px;
}
.instructions-button__text {
	font-size: 15px;
}
</style>
